/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import PrescriptionFilter from "./Popup/PrescriptionFilter";
import SavePrescriptionPopup from "components/Common/Popup/SavePrescriptionPopup";

const PrescriptionsSection = ({
  patientObj = null,
  doctorObj = null,
  clinicObj = null,
}) => {
  const params = useParams();
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [prescriptionList, setPrescriptionList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedPrescriptionIds, setSelectedPrescriptionIds] = useState([]);
  const [selectedPrescriptionId, setSelectedPrescriptionId] = useState(null);

  //json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  //function for get all prescriptions
  const getAllPrescriptions = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MEDICAL_DOCUMENT +
        `?token=${token}&members=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in get all prescriptions", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      // console.log("response", response);

      if (response.status) {
        setPrescriptionList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for update bulk prescription
  const updateBulkPrescriptionHandler = async () => {
    if (selectedPrescriptionIds.length > 0) {
      try {
        const prescriptionListToBeUpdate = prescriptionList
          .filter((item) => selectedPrescriptionIds.includes(item._id))
          .map((item) => {
            return {
              _id: item._id,
              name: item.name,
              provider: item.provider,
              testdate: item.testdate,
              resultdate: item.resultdate,
              referredby: item.referredby,
            };
          });

        let apiData = {
          medicaldocumentlist: prescriptionListToBeUpdate,
        };

        // console.log("apiData in update bulk prescription handler", apiData);

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_MEDICAL_DOCUMENT +
          `?token=${token}`;

        const response = await putData(requestURL, apiData);

        // console.log("response in update bulk prescription handler", response);

        if (response.status) {
          setTimeout(() => {
            setSelectedPrescriptionIds([]);
            setRowSelection({});
          }, 1500);
        }
      } catch (error) {}
    } else {
    }
  };

  //function for delete bulk prescription
  const deletePrescriptionHandler = async () => {
    if (selectedPrescriptionIds.length > 0) {
      try {
        const prescriptionListToBeDelete = prescriptionList.filter((item) =>
          selectedPrescriptionIds.includes(item._id)
        );

        let apiData = {
          medicaldocumentlist: prescriptionListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_DOCUMENT +
          `?token=${token}`;

        const response = await putData(requestURL, apiData);

        console.log(response);

        if (response.status) {
          setTimeout(() => {
            setPrescriptionList((prevList) =>
              prevList.filter(
                (item) => !selectedPrescriptionIds.includes(item._id)
              )
            );

            setSelectedPrescriptionIds([]);
            setRowSelection({});
          }, 1500);
        }
      } catch (error) {}
    } else {
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setPrescriptionList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  //function for reset
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  // useEffect(() => {
  //   getAllPrescriptions();
  // }, []);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllPrescriptions();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllPrescriptions();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#savePrescriptionOffCanvas"
            aria-controls="savePrescriptionOffCanvas"
            onClick={() => {
              setSelectedPrescriptionId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Name",
        accessorKey: "name",
        size: 200,
      },
      {
        header: "Referred By",
        accessorKey: "doctorname",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Provider",
        accessorKey: "clinicname",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.clinicname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Diseases",
        accessorKey: "diseasescount",
      },
      {
        header: "Medications",
        accessorKey: "medicationscount",
      },
      {
        header: "Lab Tests",
        accessorKey: "laboratorytestscount",
      },
      {
        header: "Test Date",
        accessorKey: "testdate",
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">
                {getDateFormatInSpanish(row.original.testdate)}
              </span>
            </p>
          </div>
        ),
      },
      {
        header: "Result Date",
        accessorKey: "resultdate",
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">
                {getDateFormatInSpanish(row.original.resultdate)}
              </span>
            </p>
          </div>
        ),
      },
    ],
    [] // Remove editingCell, editingValue dependencies
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedPrescriptionIds(selectedIdsArray);
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-lg-4">
            <h3 className="mb-0">Prescriptions</h3>
          </div>
          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>
            {/* <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-gray text-start w-100 dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
              >
                Action
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm fw-semibold border-0 rounded-10 shadow-sm">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-1"
                    onClick={updateBulkPrescriptionHandler}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      progress_activity
                    </span>
                    <span className="d-block">Update</span>
                  </Link>
                </li>
                <hr className="dropdown-divider" />
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-1"
                    data-bs-toggle="modal"
                    data-bs-target="#deletewarning"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">Delete</span>
                  </Link>
                </li>
              </ul>
            </div> */}
            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#prescriptionFilter"
              aria-controls="prescriptionFilter"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#savePrescriptionOffCanvas"
              aria-controls="savePrescriptionOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>

      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={prescriptionList}
            enableGrouping // to enable grouping of column
            enableRowSelection // enable showing checkbox in each row
            getRowId={(row) => row._id}
            onRowSelectionChange={setRowSelection}
            state={{ rowSelection, columnOrder }}
            initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50, //make columns wider by default
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      {/* popup section */}
      <SavePrescriptionPopup
        patientObj={patientObj}
        doctorObj={doctorObj}
        clinicObj={clinicObj}
        selectedPrescriptionId={selectedPrescriptionId}
        setSelectedPrescriptionId={setSelectedPrescriptionId}
        afterActionClose={afterActionClose}
      />

      <PrescriptionFilter
        columnOrder={columnOrder}
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        moduleSlug="patientprescriptionlist"
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        columns={columns}
      />

      <DeleteWarningModal
        moduleName={"prescription"}
        onDelete={deletePrescriptionHandler}
        onCancelDelete={() => {
          setRowSelection({});
          setSelectedPrescriptionIds([]);
        }}
      />
    </div>
  );
};

export default PrescriptionsSection;
